import { object, string, ZodIssueCode } from 'zod';

import { makeZodValidate as makeValidate } from '@occc-app/design-system';
import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

export const targetFormSchema = object({
  inAudience: object({
    audience: object({
      uuid: string().optional(),
    })
      .optional()
      .nullable(),
  })
    .optional()
    .superRefine((value, ctx) => {
      if (!value?.audience?.uuid) {
        ctx.addIssue({
          code: ZodIssueCode.custom,
          message: IS_REQUIRED,
          path: ['audience'],
        });
      }
    }),
});

export const validateTarget = makeValidate(targetFormSchema);
